export enum SlideType {
  video = 0,
  image = 1,
  discussion = 2,
  interactiveQuiz = 3,
  interactivePoll = 4,
  soloQuiz = 5,
  professorFeedback = 6,
  processingData = 7,
  sessionResults = 8,
  exhibitGrid = 9,
  groupQuiz = 10,

  grading = 11,
  endOfSession = 12,
  sortedSoloInput = 13,
  sortedGroupInput = 14,
  sortedGroupInteractive = 15,
  iframe = 16,
  animatedCards = 17,
  markdown = 18,
  learningObjectives = 19,
  interactiveForm = 20,
  sharedGoogleDoc = 21,
}

export enum ExhibitGridDisplayMode {
  all = 0,
  upToNow = 1,
  currentSlide = 2,
}

export class UnsupportedMediaTypeError extends Error {
  name = 'UnsupportedMediaTypeError'
}
